import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const PredicateCalculus = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Predicate calculus"
    videos={[
      "https://www.youtube.com/embed/8Do6tC7ZDG0?list=PLXj4XH7LcRfBB-4hXp4XI84HOCWkaBD63",
      "https://www.youtube.com/embed/UgP-HYRc3Yo?list=PLXj4XH7LcRfBB-4hXp4XI84HOCWkaBD63",
      "https://www.youtube.com/embed/S_5b_N27Rrs?list=PLXj4XH7LcRfBB-4hXp4XI84HOCWkaBD63",
      "https://www.youtube.com/embed/GP6e-HZhNNY?list=PLXj4XH7LcRfBB-4hXp4XI84HOCWkaBD63",
      "https://www.youtube.com/embed/coT7niWRey4?list=PLXj4XH7LcRfBB-4hXp4XI84HOCWkaBD63"
    ]}
    takeaways={[
      { text: `"Every..." or "All..." : ∀x (P(x) → Q(x))` },
      { text: `"Some..." or "At least one..." : ∃x (P(x) ∩ Q(x))` }
    ]}
    questions={[
      "Show that (Ǝx)(F(x)∧S(x))→(y)(M(y)→W(y)) and (Ǝy)(M(y)→W(y)) imply (x)(F(x)→not S(x))",
      "Verify whether the hypothesis “All hummingbirds are richly coloured”, “No large birds live on honey”, “Birds that do not live on honey are dull in colour” lead to the conclusion “Hummingbirds are small”.",
      "Verify the validity of the argument: \"Every student in this University is studying either an Engineering or Technology. Jini is a student in this university and she is not studying engineering. All Technology students have received their placement order. Therefore, JIni has received her placement order.\""
    ]}
    exampleVideos={[]}
  />
);
}

export default PredicateCalculus;
